var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5445 2.84C17.0084 2.37608 17.7606 2.37608 18.2245 2.84L21.1599 5.77539C21.6238 6.23931 21.6238 6.99147 21.1599 7.45538L20.1122 8.50308C19.8803 8.73504 19.5042 8.73504 19.2722 8.50308L15.4968 4.72769C15.2649 4.49573 15.2649 4.11965 15.4968 3.8877L16.5445 2.84Z",
    stroke: "#9C2D56",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2369 5.14798C14.7008 4.68406 15.453 4.68406 15.9169 5.14798L18.8523 8.08337C19.3162 8.54729 19.3162 9.29945 18.8523 9.76337L9.77629 18.8394C9.72989 18.8858 9.65468 18.8858 9.60829 18.8394L5.1609 14.392C5.11451 14.3456 5.11451 14.2704 5.1609 14.224L14.2369 5.14798Z",
    stroke: "#9C2D56",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0433 14.5432C5.05715 14.4463 5.17568 14.4068 5.2449 14.476L9.52429 18.7554C9.59351 18.8246 9.554 18.9431 9.45709 18.957L5.87567 19.4686C5.09167 19.5806 4.41967 18.9086 4.53167 18.1246L5.0433 14.5432Z",
    stroke: "#9C2D56",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7L7.5 16.5",
    stroke: "#9C2D56",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.86e4dfed0384306631cccad01cfbf233.svg";
export { ForwardRef as ReactComponent };